import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';
import ComponentWrapper from '../../common/ComponentWrapper';

import CommonStyles from '../../common/CommonStyles';
import TrplForm from '../../common/TrplForm/TrplForm';

import TrplsTable from '../../common/TrplsTable/TrplsTable';
import { getUrlParameter } from '../../utils';

import { updateJelsFromGetView } from '../../reducer/jelsReducer';

const styles = {
  ...CommonStyles,
};

class TableAndForm extends ComponentWrapper {
  state = {
    jelId: 0,
    nodeId: 0,
    jel: null,
  };

  componentDidMount = () => {
    const nodeId = +(getUrlParameter('node'));
    const jelId = +(getUrlParameter('id'));
    
    this.getJelData(jelId, nodeId);
  };

  getJelData = (jelId = 0, nodeId = 0) => {
    if (jelId) {
      this.get({
        url: `/get_jel?id=${jelId}&recursive=true`,
        cb: (res) => {
          this.props.updateJelsFromGetView(res.jels);
          this.setState({ jel: res.jels[jelId], nodeId, jelId });
        }
      })
    } else if (nodeId) {
      this.setState({ nodeId });
    }
  };
    
  render() {
    const { classes } = this.props;
    const { nodeId, jelId, jel } = this.state;

    const formTitle = jel ? jel.title : nodeId || (jel && +jel.concept);

    return (
      <div>
        {!jel && !nodeId ? (
          <div className={`${classes.container} ${classes.justifyCenter}`}>
            <h1 id={'unknown_element_msg'} hidden>Element with this id was removed or not created</h1>
          </div>
        ) : (
          <div>
            {(jel && jel.type === 'form') || (!jel && nodeId) ? (
              <div className={`${classes.p20} ${classes.pb120}`}>
                <TrplForm
                  mode={(nodeId && (!jel || (jel && jel.concept !== nodeId))) ? "edit" : "view"}
                  iId={nodeId}
                  formId={jelId}
                  formTitle={formTitle}
                  formConceptId={+jel.concept}
                  tabs={jel.tabsTitles}
                />
              </div>
            ) : jel && jel.type === 'table' ? (
              <TrplsTable settings={jel} />
            ) : (
              <span className={classes.red}>Something went wrong :(</span>
            )}
          </div>
        )}
      </div>
    );
  };
};

export default connect((state) => ({}), { updateJelsFromGetView })(withStyles(styles)(TableAndForm));
